// Updated and accurate to prod db as of Aug 22 2024
export var PRODUCT_TYPE;
(function (PRODUCT_TYPE) {
    PRODUCT_TYPE["ADJUSTMENT_GENERAL"] = "ADJUSTMENT_GENERAL";
    PRODUCT_TYPE["ADJUSTMENT_RENT"] = "ADJUSTMENT_RENT";
    PRODUCT_TYPE["ADJUSTMENT_SERVICES"] = "ADJUSTMENT_SERVICES";
    PRODUCT_TYPE["AUTO_EQUITY_PURCHASE"] = "AUTO_EQUITY_PURCHASE";
    PRODUCT_TYPE["BETA_EQUITY_BOOST_CREDIT"] = "BETA_EQUITY_BOOST_CREDIT";
    PRODUCT_TYPE["BETA_INSURANCE_DISCOUNT_CREDIT"] = "BETA_INSURANCE_DISCOUNT_CREDIT";
    PRODUCT_TYPE["BETA_RENT_DEPOSIT"] = "BETA_RENT_DEPOSIT";
    PRODUCT_TYPE["CARRYING_COST"] = "CARRYING_COST";
    PRODUCT_TYPE["CO_FINANCING_INTEREST"] = "CO_FINANCING_INTEREST";
    PRODUCT_TYPE["CONDO_FEES"] = "CONDO_FEES";
    PRODUCT_TYPE["CONTRACTUAL_RENT"] = "CONTRACTUAL_RENT";
    PRODUCT_TYPE["EQUITY_ADMIN_FEE"] = "EQUITY_ADMIN_FEE";
    PRODUCT_TYPE["EQUITY_BOOST"] = "EQUITY_BOOST";
    PRODUCT_TYPE["EQUITY_PURCHASE"] = "EQUITY_PURCHASE";
    PRODUCT_TYPE["EQUITY_REDEMPTION"] = "EQUITY_REDEMPTION";
    PRODUCT_TYPE["HOME_SEARCH_EQUITY_DEPOSIT"] = "HOME_SEARCH_EQUITY_DEPOSIT";
    PRODUCT_TYPE["HAAS_FEE"] = "HAAS_FEE";
    PRODUCT_TYPE["HOME_ONBOARDING_FEE"] = "HOME_ONBOARDING_FEE";
    PRODUCT_TYPE["HYDRO"] = "HYDRO";
    PRODUCT_TYPE["INITIAL_INVESTMENT"] = "INITIAL_INVESTMENT";
    PRODUCT_TYPE["INSPECTION_FEE"] = "INSPECTION_FEE";
    PRODUCT_TYPE["LOCKER"] = "LOCKER";
    PRODUCT_TYPE["MOVING_SERVICES"] = "MOVING_SERVICES";
    PRODUCT_TYPE["OCCUPANCY_PAYMENT"] = "OCCUPANCY_PAYMENT";
    PRODUCT_TYPE["OWNERSHIP_SAVINGS"] = "OWNERSHIP_SAVINGS";
    PRODUCT_TYPE["OWNERSHIP_SAVINGS_REINVESTMENT"] = "OWNERSHIP_SAVINGS_REINVESTMENT";
    PRODUCT_TYPE["PARKING"] = "PARKING";
    PRODUCT_TYPE["REFUND"] = "REFUND";
    PRODUCT_TYPE["REMAINING_DEPOSITS"] = "REMAINING_DEPOSITS";
    PRODUCT_TYPE["RENT"] = "RENT";
    PRODUCT_TYPE["RENT_EQUIVALENT"] = "RENT_EQUIVALENT";
    PRODUCT_TYPE["REPAIR_AND_MAINTENANCE"] = "REPAIR_AND_MAINTENANCE";
    PRODUCT_TYPE["RESIDENT_INSURANCE"] = "RESIDENT_INSURANCE";
    PRODUCT_TYPE["RESIDENT_ONBOARDING_FEE"] = "RESIDENT_ONBOARDING_FEE";
    PRODUCT_TYPE["RESIDENT_SOURCING_FEE"] = "RESIDENT_SOURCING_FEE";
    PRODUCT_TYPE["SALES_TAX"] = "SALES_TAX";
    PRODUCT_TYPE["SUITE_EXPENSES"] = "SUITE_EXPENSES";
    PRODUCT_TYPE["WATER"] = "WATER";
    PRODUCT_TYPE["WEAR_AND_TEAR_CHARGE"] = "WEAR_AND_TEAR_CHARGE";
})(PRODUCT_TYPE || (PRODUCT_TYPE = {}));
//# sourceMappingURL=Product.js.map